import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';
import { FormattedMessage } from 'react-intl';
import Typography from '../Typography';
import ThankYouModal from './ReviewSuccess';
import SorryModal from './ReviewError';
import { Button } from '../Button';
import Rating from '../Rating';
import reviewStyles from './writeReview-tw-styles';
import readreviewTwStyles from '../ReadReview/readreview-tw-styles';
import TextField from '../TextField';
import Checkbox from '../Selectors/Checkbox';
import {
  YearOptions,
  MonthOptions,
  FormatttedDate,
} from '../../../utils/dateHelper';
import WriteReviewRating from './WriteReviewRating';

const WriteReview = observer(class WriteReview extends React.Component {
      modalRef = React.createRef();
      summaryErrorRef = React.createRef();
      descriptionErrorRef = React.createRef();
      nicknameErrorRef = React.createRef();
      dobMonthErrorRef = React.createRef();
      dobYearErrorRef = React.createRef();
      emailErrorRef = React.createRef();
      hairTypeErrorRef = React.createRef();
      previewReactionDisposer = null;

      ignoreNextMonthChange = false;
      lastDobMonthValue = '';

      state = {
        monthListOpen: false,
      };

    componentDidUpdate(prevProps) {
      const modalNode = this.modalRef.current;
      if (this._removeFocusTrap) {
        this._removeFocusTrap();
        this._removeFocusTrap = null;
}

      if (modalNode) {
        const focusableSelectors = [
          'button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'
        ];
        const getFocusableElements = () => {
          return Array.from(modalNode.querySelectorAll(focusableSelectors.join(','))).filter(el => {
            if (el.hasAttribute('disabled')) return false;
            if (el.getAttribute('aria-hidden') === 'true') return false;
            if (el.closest('[aria-hidden="true"]')) return false;
            const style = window.getComputedStyle(el);
            return style.display !== 'none' && style.visibility !== 'hidden';
          });
        };

        const handleKeyDown = e => {
          const focusableEls = getFocusableElements();
          if (!focusableEls.length) return;

          const firstEl = focusableEls[0];
          const lastEl = focusableEls[focusableEls.length - 1];
          const activeElement = document.activeElement;

          if (e.key === 'Tab') {
            if (e.shiftKey) {
              if (activeElement === firstEl || activeElement === modalNode || !modalNode.contains(activeElement)) {
                e.preventDefault();
                lastEl.focus();
              }
            } else {
              if (activeElement === lastEl || !modalNode.contains(activeElement)) {
                e.preventDefault();
                firstEl.focus();
              }
            }
          }
          if (e.key === 'Escape') {
            if (typeof this.cancel === 'function') this.cancel();
          }
        };

        modalNode.addEventListener('keydown', handleKeyDown);
        this._removeFocusTrap = () => modalNode.removeEventListener('keydown', handleKeyDown);
      }
    }
  static propTypes = {
    form: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.shape({
        fields: PropTypes.object,
      }),
    ]).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    prodID: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    backLink: PropTypes.string.isRequired,
    validateField: PropTypes.func.isRequired,
    ratingOrder: PropTypes.oneOfType([PropTypes.array]).isRequired,
    onPreviewChange: PropTypes.func,
  };
  static defaultProps = {
    onCancel: () => null,
    onPreviewChange: () => null,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    // Set up MobX reaction to watch for preview state changes
    this.previewReactionDisposer = reaction(
      () => this.props.form.fields.preview.value,
      (previewValue) => {
        if (this.props.onPreviewChange) {
          this.props.onPreviewChange(previewValue);
        }
      }
    );
  }

  componentWillUnmount() {
    if (this._removeFocusTrap) {
      this._removeFocusTrap();
      this._removeFocusTrap = null;
    }
    // Clean up the reaction
    if (this.previewReactionDisposer) {
      this.previewReactionDisposer();
    }
  }

  cancel = () => {
    const { onCancel } = this.props;
    onCancel();
  };

  previewClick = e => {
    e.preventDefault();
    const { form, onSubmit, prodID } = this.props;
    form.fields.productID.value = prodID;
    onSubmit(e.target.name);
    // Preview state will be synced automatically via MobX reaction
  };

  openMonthList = () => {
    // remove placeholder only when the list is going to open
    this.setState({ monthListOpen: true });
  };

  closeMonthList = () => {
    // restore placeholder when list closes (blur/change)
    this.setState({ monthListOpen: false });
  };

  render() {
    let {
      locale,
      backLink,
      validateField,
      onSubmit,
      form,
      onChange,
      ratingOrder,
    } = this.props;
    let formData = form.fields;
    let localeValue = locale.toLowerCase();
    const i18nMessages = require(`../../../constants/messages/${locale}`);
    let termsLink = i18nMessages.writeReviewTermsLink;
    let reviewLink = `/${localeValue}/orientacoes-para-analise`;
    /* PREVIEW CLICK TO OPEN CONFIMATION MODAL */
    if (formData.preview.value === true) {
      setTimeout(function() {
        let recommendValue = formData.recommend.value;
        let recommendDiv = document.getElementById('recommend');
        let notrecommendDiv = document.getElementById('notRecommend');

        if (recommendDiv) {
          if (recommendValue == 'True') {
            notrecommendDiv.classList.add('hidden');
          } else if (recommendValue == 'False') {
            recommendDiv.classList.add('hidden');
          }
        }
      }, 100);
    }

    let radioOnClick = e => {
      // Handle radio button selection for recommend field
      if (e.target.name == 'recommendYes' || e.target.name == 'recommendNo') {
        onChange('recommend', e.target.value);
        validateField('recommend');
        // Uncheck the other radio button
        if (e.target.name == 'recommendYes') {
          const noRadio = document.getElementById('recommended1');
          if (noRadio) noRadio.checked = false;
        } else {
          const yesRadio = document.getElementById('recommended2');
          if (yesRadio) yesRadio.checked = false;
        }
      } else {
        onChange(e.target.name, e.target.value);
        if (e.target.name == 'recommend' || e.target.name == 'overallRating') {
          validateField(e.target.name);
        }
      }
    };

    let checkboxOnClick = e => {
      var checkBox = document.getElementById('termsAndConditions');
      if (checkBox.checked == true) {
        e.target.value = formData.terms.value = true;
      } else {
        e.target.value = formData.terms.value = '';
      }
      onChange(e.target.name, e.target.value);
      validateField(e.target.name);
    };

    let checkboxOnBlur = e => {
      validateField(e.target.name);
    };

    let nicknameKeyDown = e => {
      if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.nickname.value || formData.nickname.value.trim() === '') {
          e.preventDefault();
          validateField('nickname');
          setTimeout(() => {
            if (this.nicknameErrorRef.current) {
              this.nicknameErrorRef.current.focus();
            }
          }, 50);
        }
      }
    };

    let summaryKeyDown = e => {
      if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.summary.value || formData.summary.value.trim() === '') {
          e.preventDefault();
          validateField('summary');
          setTimeout(() => {
            if (this.summaryErrorRef.current) {
              this.summaryErrorRef.current.focus();
            }
          }, 50);
        }
      }
    };

    let descriptionKeyDown = e => {
      if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.description.value || formData.description.value.trim() === '') {
          e.preventDefault();
          validateField('description');
          setTimeout(() => {
            if (this.descriptionErrorRef.current) {
              this.descriptionErrorRef.current.focus();
            }
          }, 50);
        }
      }
    };

    let dobMonthKeyDown = e => {
      if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.dobMonth.value || formData.dobMonth.value === '') {
          e.preventDefault();
          validateField('dobMonth');
          setTimeout(() => {
            if (this.dobMonthErrorRef.current) {
              this.dobMonthErrorRef.current.focus();
            }
          }, 50);
        }
      }
    };

    let dobYearKeyDown = e => {
      if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.dobYear.value || formData.dobYear.value === '') {
          e.preventDefault();
          validateField('dobYear');
          setTimeout(() => {
            if (this.dobYearErrorRef.current) {
              this.dobYearErrorRef.current.focus();
            }
          }, 50);
        }
      }
    };

    let emailKeyDown = e => {
      if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.email.value || formData.email.value.trim() === '') {
          e.preventDefault();
          validateField('email');
          setTimeout(() => {
            if (this.emailErrorRef.current) {
              this.emailErrorRef.current.focus();
            }
          }, 50);
        }
      }
    };

    let hairTypeKeyDown = e => {
      if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.hairType.value || formData.hairType.value === '') {
          e.preventDefault();
          validateField('hairType');
          setTimeout(() => {
            if (this.hairTypeErrorRef.current) {
              this.hairTypeErrorRef.current.focus();
            }
          }, 50);
        }
      }
    };

    let checkboxOnKeyDown = e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        var checkBox = document.getElementById('termsAndConditions');
        checkBox.checked = !checkBox.checked;
        var syntheticEvent = {
          target: checkBox,
          preventDefault: () => {}
        };
        checkboxOnClick(syntheticEvent);
      } else if (e.key === 'Tab' && !e.shiftKey) {
        if (!formData.terms.value) {
          validateField('terms');
        }
      }
    };

    let submitClick = e => {
      let preview = formData.preview;
      preview.value = false;
      let submit = formData.isSubmit;
      submit.value = true;
      onSubmit(e.target.name);
      // Preview state will be synced automatically via MobX reaction
    };

    let closeClick = () => {
      let preview = formData.preview;
      preview.value = false;
      // Do not set focus to the modal or form after closing; let focus return naturally
    };
    let hairTypesArray = [
      'Fino',
      'Normal-grosso',
      'Cacheado',
      'Liso',
      'Com relaxamento',
      'Natural',
    ];
    let hairLengthArray = ['Curto', 'Médio', 'Comprido'];
    let hairNeedArray = ['Seco', 'Oleoso', 'Tingido', 'Danificado'];
    
    // Generate years and months arrays for DOB
    let d = new Date();
    let curr_year = d.getFullYear();
    let yearsArray = [];
    let monthsArray = [];
    let limitYear = curr_year - 118;
    let limitMonth = 12;
    for (let i = curr_year; i >= limitYear; i--) {
      yearsArray.push(i);
    }
    for (let i = 1; i <= limitMonth; i++) {
      monthsArray.push(i);
    }
    
    let HairTypeOptions = hairTypesArray.map((eachValue, i) => {
      const isSelected = formData.hairType.value === eachValue;
      return (
        <option 
          value={eachValue} 
          key={i}
          aria-label={isSelected ? `${eachValue}, selected` : `${eachValue}`}
        >
          {eachValue}
        </option>
      );
    });
    let HairLengthOptions = hairLengthArray.map((eachValue, i) => {
      const isSelected = formData.hairLength.value === eachValue;
      return (
        <option 
          value={eachValue} 
          key={i}
          aria-label={isSelected ? `${eachValue}, selected` : `${eachValue}`}
        >
          {eachValue}
        </option>
      );
    });
    let HairNeedOptions = hairNeedArray.map((eachValue, i) => {
      const isSelected = formData.hairNeed.value === eachValue;
      return (
        <option 
          value={eachValue} 
          key={i}
          aria-label={isSelected ? `${eachValue}, selected` : `${eachValue}`}
        >
          {eachValue}
        </option>
      );
    });
    
    let MonthOptionsLocal = monthsArray.map((eachValue, i) => {
      const isSelected = formData.dobMonth.value == eachValue;
      return (
        <option 
          value={eachValue} 
          key={i}
          aria-label={`${eachValue}`}
        >
          {eachValue}
        </option>
      );
    });
    
    let YearOptionsLocal = yearsArray.map((eachValue, i) => (
      <option value={eachValue} key={i}>
        {eachValue}
      </option>
    ));

    return (
      <div
        ref={this.modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="previewModalTitle"
        tabIndex={-1}
      >
        {formData.serverErrorFlag.value == true ? (
          <div role="alert" aria-live="assertive">
            <p>
              <Typography
                component="div"
                className={classNames(
                      reviewStyles.reviewForm.serverErrorText
                    )}
              >
                <FormattedMessage
                  id={formData.serverError.value}
                  defaultMessage={i18nMessages.ageCriteriaError}
                  values={{
                        pgUrl: (
                          <a
                            rel="noopener noreferrer"
                            data-pgaction-redirection="0"
                            className={classNames(
                              reviewStyles.reviewForm.pgUrl
                            )}
                            href="https://www.pg.com/"
                            target="_blank"
                          >
                            {`www.pg.com`}
                          </a>
                        ),
                      }}
                />
              </Typography>
            </p>
          </div>
            ):(!formData.thankyou.value && !formData.sorryModal.value) ? (
              <form
                autoComplete="off"
                className={
              formData.preview.value
                ? classNames(reviewStyles.reviewForm.modalPositionHidden)
                : classNames(reviewStyles.reviewForm.modalPositionShow)
            }
              >
                <input type="hidden" name="blackBox" id="ioBlackBox" />
                <Typography
                  component="h2"
                  className={classNames(reviewStyles.writeReviewHeading)}
                >
                  <FormattedMessage
                    id="writeReviewHeader"
                    defaultMessage={i18nMessages.writeReviewHeader}
                  />
                </Typography>
            
                <div className={classNames(reviewStyles.reviewForm.ratingWrapper)}>
                  {formData.errorLength.value > 0 && (
                  <Typography
                    component="div"
                    className={classNames(reviewStyles.reviewForm.pageError)}
                    aria-hidden="true"
                    role="alert"
                    aria-live="assertive"
                    
                  >
                    {i18nMessages.writeReviewError.replace(
                    '#number',
                    formData.errorLength.value
                  )}
                  </Typography>
              )}
                  <span
                    className={classNames(reviewStyles.reviewForm.mandateField)}
                  >
                    <span className="mandatory_field_star">*</span>
                    {
                      <FormattedMessage
                        id="mandatoryField"
                        defaultMessage={i18nMessages.mandatoryField}
                      />
                }
                  </span>
                   {ratingOrder.map((eachType, index) => {
                return (
                  <WriteReviewRating
                    key={index}
                    formData={formData}
                    type={eachType}
                    onChange={onChange}
                    validateField={validateField}
                   />  );
                   })} 
                  <div
                    className={classNames(
                  reviewStyles.reviewForm.recommendContainer
                )}
                  >
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.recommendLabelContainer
                  )}
                    >
                      <label
                        className={classNames(
                      reviewStyles.reviewForm.recommendLabel
                    )}
                        htmlFor="recommendLab"
                        tabIndex={0}
                        aria-label={i18nMessages.recommendLabel}
                        style={{outline: 'none'}}
                      >
                        {
                          <FormattedMessage
                            id="recommendLabel"
                            defaultMessage={i18nMessages.recommendLabel}
                          />
                    }
                        <span className="mandatory_field_star">*</span>
                      </label>
                    </div>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.recommendradioContain
                  )}
                    >
                      <div aria-label={i18nMessages.recommendLabel}>
                        <span>
                          <label
                            className={classNames(
                          reviewStyles.reviewForm.recommendlabelClass
                        )}
                            htmlFor="recommended2"
                            title=""
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                document.getElementById('recommended2').click();
                              }
                            }}
                          >
                            <span className="sr-only">
                              {formData.recommend.value === 'True' ? `${i18nMessages.writeReviewYes} selecionado` : `${i18nMessages.writeReviewYes} não selecionado`}
                            </span>
                            <span aria-hidden="true">{i18nMessages.writeReviewYes}</span>
                          </label>
                          <input
                            type="radio"
                            className={classNames(
                          reviewStyles.reviewForm.recommendedRadio
                        )}
                            id="recommended2"
                            name="recommendYes"
                            onChange={radioOnClick}
                            value="True"
                            checked={formData.recommend.value === 'True'}
                            tabIndex={-1}
                          />
                        </span>

                        <span>
                          <label
                            className={classNames(
                          reviewStyles.reviewForm.recommendlabelClass
                        )}
                            htmlFor="recommended1"
                            title=""
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                document.getElementById('recommended1').click();
                              } else if (e.key === 'Tab' && !e.shiftKey) {
                                if (!formData.recommend.value) {
                                  validateField('recommend');
                                }
                              }
                            }}
                          >
                            <span className="sr-only">
                              {formData.recommend.value === 'False' ? `${i18nMessages.writeReviewNo} selecionado` : `${i18nMessages.writeReviewNo} não selecionado`}
                            </span>
                            <span aria-hidden="true">{i18nMessages.writeReviewNo}</span>
                          </label>
                          <input
                            type="radio"
                            className={classNames(
                          reviewStyles.reviewForm.recommendedRadio
                        )}
                            id="recommended1"
                            name="recommendNo"
                            onChange={radioOnClick}
                            value="False"
                            checked={formData.recommend.value === 'False'}
                            tabIndex={-1}
                          />
                        </span>
                      </div>
                      {formData.recommend.error && (
                      <p
                        ref={this.recommendErrorRef}
                        className={classNames(reviewStyles.reviewForm.errorText)}
                        role="alert" aria-live="assertive"
                        tabIndex={0}
                      >
                        <FormattedMessage
                          id="recommendRequiredError"
                          defaultMessage={i18nMessages.recommendRequiredError}
                        />
                      </p>
                  )}
                    </div>
                  </div>
                </div>

                <div className={classNames(reviewStyles.reviewForm.reviewWrapper)}>
                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <TextField
                      type="text"
                      id="summary"
                      name="summary"
                      value={formData.summary.value}
                      onChange={e => onChange(e.target.name, e.target.value)}
                      onBlur={e => validateField(e.target.name)}
                      onKeyDown={summaryKeyDown}
                      className={classNames(reviewStyles.reviewForm.inputBox)}
                    />
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="summary"
                      >
                        {
                          <FormattedMessage
                            id="reviewSummaryLabel"
                            defaultMessage={i18nMessages.reviewSummaryLabel}
                          />
                    }
                        <span className="mandatory_field_star">*</span>
                      </label>
                    </div>
                    <div
                      className={classNames(reviewStyles.reviewForm.textboxContain)}
                    >
                      {formData.summary.error && (
                      <p
                        ref={this.summaryErrorRef}
                        className={classNames(reviewStyles.reviewForm.errorText)}
                        role="alert" aria-live="assertive"
                        tabIndex={0}
                      >
                        <FormattedMessage
                          id="summaryRequiredError"
                          defaultMessage={i18nMessages.summaryRequiredError}
                        />
                      </p>
                  )}
                      <span
                        className={classNames(
                      reviewStyles.reviewForm.labelHintText
                    )}
                      >
                        {
                          <FormattedMessage
                            id="reviewSummaryHint"
                            defaultMessage={i18nMessages.reviewSummaryHint}
                          />
                    }
                      </span>
                    </div>
                  </div>
                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <TextField
                      multiRow="true"
                      id="description"
                      name={formData.description.name}
                      cols="20"
                      rows="2"
                      maxlength="500"
                      minlength="50"
                      value={formData.description.value}
                      onChange={e => onChange(e.target.name, e.target.value)}
                      onBlur={e => validateField(e.target.name)}
                      onKeyDown={descriptionKeyDown}
                      className={classNames(reviewStyles.reviewForm.textArea)}
                    />
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="description"
                      >
                        {
                          <FormattedMessage
                            id="reviewLabel"
                            defaultMessage={i18nMessages.reviewLabel}
                          />
                    }
                        <span className="mandatory_field_star">*</span>
                      </label>
                    </div>
                    <div
                      className={classNames(reviewStyles.reviewForm.textboxContain)}
                    >
                      {formData.description.error && (
                      <p
                        ref={this.descriptionErrorRef}
                        className={classNames(reviewStyles.reviewForm.errorText)} tabIndex={0}
                      >
                        <FormattedMessage
                          id={formData.description.error}
                          defaultMessage={i18nMessages.descriptionRequiredError}
                        />
                      </p>
                  )}

                      <span
                        className={classNames(
                      reviewStyles.reviewForm.labelHintText
                    )}
                      >
                        {
                          <FormattedMessage
                            id="reviewHint"
                            defaultMessage={i18nMessages.reviewHint}
                          />
                    }
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(reviewStyles.reviewForm.informationWrapper)}
                >
                  <h3
                    className={classNames(reviewStyles.reviewForm.sectionHeading)}
                  >
                    {
                      <FormattedMessage
                        id="informationHeader"
                        defaultMessage={i18nMessages.informationHeader}
                      />
                }
                  </h3>
                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <TextField
                      type="text"
                      id="nickname"
                      name={formData.nickname.name}
                      value={formData.nickname.value}
                      onChange={e => onChange(e.target.name, e.target.value)}
                      onBlur={e => validateField(e.target.name)}
                      onKeyDown={nicknameKeyDown}
                      className={classNames(reviewStyles.reviewForm.inputBox)}
                    />
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="nickname"
                      >
                        {
                          <FormattedMessage
                            id="nickNameLabel"
                            defaultMessage={i18nMessages.nickNameLabel}
                          />
                    }
                        <span className="mandatory_field_star">*</span>
                      </label>
                    </div>
                    <div
                      className={classNames(reviewStyles.reviewForm.textboxContain)}
                    >
                      {formData.nickname.error && (
                      <p
                        ref={this.nicknameErrorRef}
                        className={classNames(reviewStyles.reviewForm.errorText)} tabIndex={0}
                      >
                        <FormattedMessage
                          id={formData.nickname.error}
                          defaultMessage={i18nMessages.nicknameRequiredError}
                        />
                      </p>
                  )}
                      <span
                        className={classNames(
                      reviewStyles.reviewForm.labelHintText
                    )}
                      >
                        {
                          <FormattedMessage
                            id="nickNameHint"
                            defaultMessage={i18nMessages.nickNameHint}
                          />
                    }
                      </span>
                    </div>
                  </div>

                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="dobMonth"
                        tabIndex={0}
                      >
                        {
                          <FormattedMessage
                            id="dobLabel"
                            defaultMessage={i18nMessages.dobLabel}
                          />
                    }
                        <span className="mandatory_field_star">*</span>
                      </label>
                    </div>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.textboxContain,
                    'flex overflow-hidden dob-select-box'
                  )}
                    >
                      <div
                        className={classNames(reviewStyles.reviewForm.monthWrapper)}
                      >
                        <select
                          className={classNames(
                        reviewStyles.reviewForm.selectStyle
                      )}
                          id="dobMonth"
                          name={formData.dobMonth.name}
                          value={formData.dobMonth.value}
                          onChange={(e) => {
                            // If arrow keys forced a change while collapsed, revert to placeholder
                            if (this.ignoreNextMonthChange && !this.state.monthListOpen) {
                              this.ignoreNextMonthChange = false;

                              // revert UI value back to placeholder
                              e.target.value = this.lastDobMonthValue || '';
                              onChange(e.target.name, e.target.value);
                              return;
                            }

                            this.ignoreNextMonthChange = false;
                            this.lastDobMonthValue = e.target.value;

                            onChange(e.target.name, e.target.value);
                            this.closeMonthList();
                          }}
                          onBlur={e => {
                            this.closeMonthList();
                            validateField(e.target.name);
                          }}
                          onMouseDown={() => {
                            // Mouse / touch open
                            this.openMonthList();
                          }}
                          onKeyDown={(e) => {
                            // ✅ Hard block arrow keys so "Mês" doesn't become "1" while collapsed
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                              e.stopPropagation();

                              // mark that any following native change must be ignored/reverted
                              this.ignoreNextMonthChange = true;

                              // keep last value (usually '')
                              this.lastDobMonthValue = formData.dobMonth.value || '';

                              return; // ⬅️ IMPORTANT: do not run other logic on arrow keys
                            }

                            // ✅ Only open list on Enter/Space (keyboard intent to interact)
                            if (e.key === 'Enter' || e.key === ' ') {
                              this.openMonthList();
                            }

                            // keep your existing validation/focus logic
                            dobMonthKeyDown(e);
                          }}
                          title={i18nMessages.dobMonth}
                          aria-label={
                            formData.dobMonth.value 
                              ? `${i18nMessages.dobMonth}, ${formData.dobMonth.value} selecionado`
                              : i18nMessages.dobMonth
                          }
                          aria-required="true"
                          aria-invalid={formData.dobMonth.error ? "true" : "false"}
                          aria-describedby={formData.dobMonth.error ? `${formData.dobMonth.error}` : undefined}
                        >
                          {/* Placeholder stays while collapsed to avoid browser auto-selecting "1" */}
                          {!this.state.monthListOpen && (
                            <option value="" disabled>
                              {i18nMessages.writeReviewMonth}
                            </option>
                          )}

                          {/* Real options: 1..12 only */}
                          {MonthOptionsLocal}
                        </select>
                        {formData.dobMonth.error && (
                        <p
                          ref={this.dobMonthErrorRef}
                          className={classNames(
                          reviewStyles.reviewForm.errorText
                        )}
                        tabIndex={0}
                        >
                          <FormattedMessage
                            id={formData.dobMonth.error}
                            defaultMessage={i18nMessages.dobMonthRequiredError}
                          />
                        </p>
                    )}
                      </div>
                      <div
                        className={classNames(reviewStyles.reviewForm.yearWrapper)}
                      >
                        <select
                          className={classNames(
                        reviewStyles.reviewForm.selectStyle
                      )}
                          id="dobYear"
                          name={formData.dobYear.name}
                          value={formData.dobYear.value}
                          onChange={e => onChange(e.target.name, e.target.value)}
                          onBlur={e => validateField(e.target.name)}
                          title={i18nMessages.dobYear}
                          aria-label={i18nMessages.dobYear}
                          aria-required="true"
                          aria-invalid={formData.dobYear.error ? "true" : "false"}
                          aria-describedby={formData.dobYear.error ? `${formData.dobYear.error}` : undefined}
                          onKeyDown={(e) => {
                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                          e.preventDefault();
                        }
                        dobYearKeyDown(e);
                      }}
                        >
                          <option value="" disabled hidden>
                            {i18nMessages.writeReviewYear}
                          </option>
                          {YearOptionsLocal}
                        </select>
                        {formData.dobYear.error && (
                        <p
                          ref={this.dobYearErrorRef}
                          className={classNames(
                          reviewStyles.reviewForm.errorText
                        )}
                        tabIndex={0}
                        >
                          <FormattedMessage
                            id={formData.dobYear.error}
                            defaultMessage={i18nMessages.dobYearRequiredError}
                          />
                        </p>
                    )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <TextField
                      type="text"
                      id="email"
                      name={formData.email.name}
                      value={formData.email.value}
                      onChange={e => onChange(e.target.name, e.target.value)}
                      onBlur={e => validateField(e.target.name)}
                      onKeyDown={emailKeyDown}
                      className={classNames(reviewStyles.reviewForm.inputBox)}
                    />
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="email"
                      >
                        {
                          <FormattedMessage
                            id="emailLabel"
                            defaultMessage={i18nMessages.emailLabel}
                          />
                    }
                      </label>
                    </div>
                    <div
                      className={classNames(reviewStyles.reviewForm.textboxContain)}
                    >
                      {formData.email.error && (
                      <p
                        ref={this.emailErrorRef}
                        className={classNames(reviewStyles.reviewForm.errorText)} tabIndex={0}
                      >
                        <FormattedMessage
                          id={formData.email.error}
                          defaultMessage={i18nMessages.emailRequiredError}
                        />
                      </p>
                  )}
                      <span
                        className={classNames(
                      reviewStyles.reviewForm.labelHintText
                    )}
                      >
                        {
                          <FormattedMessage
                            id="emailHint"
                            defaultMessage={i18nMessages.emailHint}
                          />
                    }
                      </span>
                    </div>
                  </div>

                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <select
                      className={classNames(reviewStyles.reviewForm.selectStyle)}
                      id="hairType"
                      name={formData.hairType.name}
                      value={formData.hairType.value}
                      onChange={e => onChange(e.target.name, e.target.value)}
                      onBlur={e => validateField(e.target.name)}
                      onKeyDown={(e) => {
                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                          e.preventDefault();
                        }
                        hairTypeKeyDown(e);
                      }}
                      title={i18nMessages.writeReviewHairType}
                    >
                      {HairTypeOptions}
                    </select>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="hairType"
                      >
                        {
                          <FormattedMessage
                            id="hairTypeLabel"
                            defaultMessage={i18nMessages.hairTypeLabel}
                          />
                    }
                        <span className="mandatory_field_star">*</span>
                      </label>
                    </div>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.textboxContain,
                    'overflow-hidden dob-select-box'
                  )}
                    >
                      <div
                        className={classNames(reviewStyles.reviewForm.monthWrapper)}
                      >
                        {formData.hairType.error && (
                        <p
                          ref={this.hairTypeErrorRef}
                          className={classNames(
                          reviewStyles.reviewForm.errorText
                        )}
                        tabIndex={0}
                        >
                          {
                            <FormattedMessage
                              id="hairTypeLabelError"
                              defaultMessage={i18nMessages.hairTypeLabelError}
                            />
                        }
                        </p>
                    )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <select
                      className={classNames(reviewStyles.reviewForm.selectStyle)}
                      id="hairLength"
                      name={formData.hairLength.name}
                      value={formData.hairLength.value}
                      onChange={e => onChange(e.target.name, e.target.value)}
                      onBlur={e => validateField(e.target.name)}
                      onKeyDown={(e) => {
                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                          e.preventDefault();
                        }
                      }}
                      title={i18nMessages.writeReviewHairLength}
                    >
                      {HairLengthOptions}
                    </select>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="hairLength"
                      >
                        {
                          <FormattedMessage
                            id="hairLengthLabel"
                            defaultMessage={i18nMessages.hairLengthLabel}
                          />
                    }
                      </label>
                    </div>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.textboxContain,
                    'overflow-hidden dob-select-box'
                  )}
                    >
                      <div
                        className={classNames(reviewStyles.reviewForm.monthWrapper)}
                      >
                        {formData.hairLength.error && (
                        <p
                          className={classNames(
                          reviewStyles.reviewForm.errorText
                        )}
                        tabIndex={0}
                        >
                          <FormattedMessage id={formData.hairLength.error} />
                        </p>
                    )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={classNames(reviewStyles.reviewForm.inputSections)}
                  >
                    <select
                      className={classNames(reviewStyles.reviewForm.selectStyle)}
                      id="hairNeed"
                      name={formData.hairNeed.name}
                      value={formData.hairNeed.value}
                      onChange={e => onChange(e.target.name, e.target.value)}
                      onBlur={e => validateField(e.target.name)}
                      onKeyDown={(e) => {
                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                          e.preventDefault();
                        }
                      }}
                      title={i18nMessages.writeReviewHairNeed}
                    >
                      {HairNeedOptions}
                    </select>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.inputLabelContain
                  )}
                    >
                      <label
                        className={classNames(reviewStyles.reviewForm.label)}
                        htmlFor="hairNeed"
                      >
                        {
                          <FormattedMessage
                            id="hairNeedLabel"
                            defaultMessage={i18nMessages.hairNeedLabel}
                          />
                    }
                      </label>
                    </div>
                    <div
                      className={classNames(
                    reviewStyles.reviewForm.textboxContain,
                    'overflow-hidden dob-select-box'
                  )}
                    >
                      <div
                        className={classNames(reviewStyles.reviewForm.monthWrapper)}
                      >
                        {formData.hairNeed.error && (
                        <p
                          className={classNames(
                          reviewStyles.reviewForm.errorText
                        )}
                        tabIndex={0}
                        >
                          <FormattedMessage id={formData.hairNeed.error} />
                        </p>
                    )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classNames(reviewStyles.reviewForm.termsWrapper)}>
                  <div
                    className={classNames(reviewStyles.reviewForm.checkboxWrapper)}
                  >
                    <div className={classNames(reviewStyles.reviewForm.termsStyle)}>
                      <checkboxgroup>
                        <Checkbox
                          id="termsAndConditions"
                          name={formData.terms.name}
                          tabIndex={0}
                          className={classNames(
                        reviewStyles.reviewForm.termsCheckbox
                      )}
                          value={formData.terms.value}
                          checked={formData.terms.value ? true : false}
                          onChange={checkboxOnClick}
                           inputProps={{
                            'aria-required': 'true',
                            'aria-invalid': formData.terms.error ? 'true' : 'false',
                            onKeyDown: checkboxOnKeyDown,
                            onBlur: checkboxOnBlur
                          }}
                        />
                        <label htmlFor="termsAndConditions">
                          {
                            <FormattedMessage
                              id="writeReviewTerms"
                              defaultMessage={i18nMessages.writeReviewTerms}
                            />
                      }
                          <span className="mandatory_field_star">*</span>
                        </label>
                      </checkboxgroup>
                      {formData.terms.error && (
                      <p
                        ref={this.termsErrorRef}
                        className={classNames(
                        reviewStyles.reviewForm.errorText,
                        reviewStyles.reviewForm.BoldError
                      )}
                        role="alert"
                        aria-live="assertive"
                        tabIndex={0}
                      >
                        <FormattedMessage
                          id={formData.terms.error}
                          defaultMessage={i18nMessages.termsRequiredError}
                        />
                      </p>
                  )}
                    </div>
                  </div>
                  <div className={classNames(reviewStyles.reviewForm.trustContent)}>
                    <p dangerouslySetInnerHTML={{ __html: i18nMessages.writeReviewTrust }}>
                    </p>
                    <p dangerouslySetInnerHTML={{ __html: i18nMessages.writeReviewTrustComm }}>
                    </p>                    
                  </div>
              
                  <div style={{ textAlign: 'center', paddingBottom: '20px' , paddingTop:'10px'}}>
                    <a
                      href="#"
                      className={classNames(
                    reviewStyles.reviewForm.previewButton,
                    'previewButton',
                    'event_preview_review'
                    )}
                      data-action-detail="review-summary"
                      aria-label='Ver avaliações'
                      role="button"
                      onClick={this.previewClick}
                    >
                      {i18nMessages.writeReviewPreview}
                    </a>
                  </div>
                 
                </div>
              </form>
        ) : (
          ''
        )}
        {formData.preview.value ? (
          <div
            className={
              (classNames(reviewStyles.sorryThanks.modalWrapper),
              formData.thankyou.value && formData.sorryModal.value
                ? 'hidden'
                : 'show')
            }
          >
            <div className={classNames(reviewStyles.sorryThanks.modalBG)}>
              <div className={classNames(reviewStyles.sorryThanks.modalTitle)}>
                <span
                  className={classNames(reviewStyles.sorryThanks.modalHeader)}
                >
                  {
                    <FormattedMessage
                      id="previewHeading"
                      defaultMessage={i18nMessages.previewHeading}
                    />
                  }
                </span>
                <Button
                  type="button"
                  className={classNames(
                    reviewStyles.sorryThanks.modalClose,
                    'modalClose',
                    'event_cancel_review'
                  )}
                  onClick={closeClick}
                  data-action-detail="cancel-review"
                  aria-label="Fechar janela pop-up."
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      closeClick(e);
                    }
                  }}
                >
                  <span
                    className={classNames(reviewStyles.sorryThanks.closeIcon)}
                  >
                    {`×`}
                  </span>
                </Button>
              </div>

              <div
                className={classNames(reviewStyles.sorryThanks.dialogWrapper)}
              >
                <div>
                  <div
                    className={classNames(
                      reviewStyles.reviewForm.dialogContentWrapper
                    )}
                  >
                    <div
                      className={classNames(
                        reviewStyles.reviewForm.dialogTextContains
                      )}
                    >
                      <div
                        className={classNames(
                          reviewStyles.reviewForm.previewleft
                        )}
                      >
                        <p
                          className={classNames(
                            reviewStyles.reviewForm.marginbten
                          )}
                        >
                          <strong>{formData.nickname.value}</strong>
                        </p>
                        <div>
                          <div
                            id="valueRating"
                            className={classNames(
                              reviewStyles.reviewForm.marginbten
                            )}
                          >
                            <p>
                              {
                                <FormattedMessage
                                  id="valueLabel"
                                  defaultMessage={i18nMessages.valueLabel}
                                />
                              }
                            </p>
                            <div
                              className={classNames(
                                reviewStyles.reviewForm.secRating
                              )}
                            >
                              <div
                                className={classNames(
                                  reviewStyles.reviewForm.secondaryValue
                                )}
                              >
                                <span />
                              </div>
                            </div>
                          </div>
                          <div
                            id="qualityRating"
                            className={classNames(
                              reviewStyles.reviewForm.marginbten
                            )}
                          >
                            <p>
                              {
                                <FormattedMessage
                                  id="qualityLabel"
                                  defaultMessage={i18nMessages.qualityLabel}
                                />
                              }
                            </p>
                            <div
                              className={classNames(
                                reviewStyles.reviewForm.secRating
                              )}
                            >
                              <div
                                className={classNames(
                                  reviewStyles.reviewForm.secondaryQuality
                                )}
                              >
                                <span />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={classNames(
                          reviewStyles.reviewForm.previewRight
                        )}
                      >
                        <div
                          className={classNames(reviewStyles.reviewForm.flex)}
                        >
                          <div
                            className={classNames(
                              reviewStyles.reviewForm.widthHalf
                            )}
                          >
                            <span>
                              <Rating rating={formData.overallRating.value} />
                            </span>
                          </div>
                          <p
                            className={classNames(
                              reviewStyles.reviewForm.widthHalf
                            )}
                          >
                            {FormatttedDate(locale)}
                          </p>
                        </div>
                        <p
                          className={classNames(
                            reviewStyles.reviewForm.reviewSummary
                          )}
                        >
                          <strong>{formData.summary.value}</strong>
                        </p>
                        <p
                          className={classNames(
                            reviewStyles.reviewForm.reviewContent
                          )}
                        >
                          {formData.description.value}
                        </p>
                        <div
                          className={classNames(
                            reviewStyles.reviewForm.reviewContent
                          )}
                        >
                          <span id="recommend">
                            {
                              <FormattedMessage
                                id="yesRecommend"
                                defaultMessage={i18nMessages.yesRecommend}
                              />
                            }
                          </span>
                          <span id="notRecommend">
                            {
                              <FormattedMessage
                                id="notRecommend"
                                defaultMessage={i18nMessages.notRecommend}
                              />
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    reviewStyles.reviewForm.previewButtonWrap
                  )}
                >
                  <button
                    type="button"
                    onClick={closeClick}
                    className={
                      classNames(reviewStyles.reviewForm.editButton) +
                      ' edit-btn'
                    }
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        closeClick(e);
                      }
                    }}
                  >
                    {
                      <FormattedMessage
                        id="reviewEditButton"
                        defaultMessage={i18nMessages.reviewEditButton}
                      />
                    }
                  </button>
                  <button
                    type="button"
                    onClick={submitClick}
                    className={
                      classNames(
                        reviewStyles.reviewForm.submitButton,
                        'event_submit_review',
                        'event_ratings_action'
                      ) + ' submit-btn'
                    }
                    data-action-detail="submit-review"
                    aria-label="Enviar avaliação"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        submitClick(e);
                      }
                    }}
                  >
                    {
                      <FormattedMessage
                        id="reviewSubmitButton"
                        defaultMessage={i18nMessages.reviewSubmitButton}
                      />
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        <ThankYouModal form={form} url={backLink} cancel={this.cancel} />
        <SorryModal form={form} />
      </div>
    );
  }
});

export default WriteReview;
